import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/researchers/onboarding')({
  // TODO: these checks duplicate what _authenticated.tsx does.
  // Ideally /onboarding should live inside _authenticated/.
  // That's not done yet because _authenticated is also a layout route in
  // addition to a being a route guard. the layout respnosibility should live under
  // projects/ as currently the project routes are also rendering a sidebar
  // underneath and are using layout hacks to cover it up.
  beforeLoad: async ({ context }) => {
    // Root-context session, not an independent `getServerSession()` — see the
    // note in `researchers/login.tsx`. This route redirects to
    // /researchers/login, which reads the same context, so the two can only
    // ever agree.
    const { user } = context;

    if (!user) throw redirect({ to: '/researchers/login' });

    if (!user.roles.includes('researcher'))
      throw redirect({ to: '/participants' });

    if (!user.isEmailVerified)
      throw redirect({ to: '/researchers/verify-email' });

    return { user, orgs: user.organizations ?? [] };
  },
});
